const Logs = {
	ENABLED: true,
	DISABLED: false,
} as const;

export const LOGS = {
	VIDEO: Logs.DISABLED,
	AUDIO: Logs.DISABLED,
	INTERACTIVE: Logs.DISABLED,
	STATE: Logs.DISABLED,
} as const;
